import React from 'react';
import PropTypes from 'prop-types';

import { getLogPresentation } from '../logPresentation';

const LogData = ({ logData, type, action }) => {
  const { title, summary } = getLogPresentation({ type, action, data: logData });
  return (
    <div className="text-[12px] text-dark text-left max-w-[420px]">
      <div className="font-medium">{title}</div>
      <div className="truncate" title={summary}>{summary}</div>
    </div>
  );
};

LogData.propTypes = {
  logData: PropTypes.shape({}),
  type: PropTypes.string,
  action: PropTypes.string,
};

LogData.defaultProps = {
  logData: null,
  type: '',
  action: ''
};

export default LogData;
